import React from 'react';
import { Image, Dropdown } from 'react-bootstrap';
import './TaxiVla.css';

const TaxiVla = () => {
  return (
    <Dropdown className="taxi-dropdown">
      <Dropdown.Toggle id="dropdown-basic">
        <Image className="logo-taxi" src="/assets/images/logo-taxi.png" />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item
          href="https://play.google.com/store/apps/details?id=com.visionblo.taxisvla.pasajero&pcampaignid=web_share"
          target="_blank"
          rel="noreferrer"
        >
          Android
        </Dropdown.Item>
        <Dropdown.Item
          href="https://apps.apple.com/ar/app/taxi-vla/id6754694575"
          target="_blank"
          rel="noreferrer"
        >
          IOS
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default React.memo(TaxiVla);
